export default "__VITE_ASSET__oFVdBsLU__"